// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__g9cMU","title":"Images90_title__332IG","images":"Images90_images__Axe4Z"};